module.exports = __webpack_public_path__ + "media/components/greenroom-articles/static/icon-caret-right-215864f492452f3e5b2c6edf924d8334.svg";